import _ from "lodash";
import React, { useState } from "react";
import { Modal, Button, MediaCard } from "@toddle-edu/ds-web";
import classes from "./ConflictingLabelModal.scss";
import RadioButtonList from "UIComponents/RadioButtonList";

const getRadioButtonOptions = ({ t }) => {
  return [
    {
      label: t("common:replace_existing"),
      value: "replaceExisting",
    },
    {
      label: t("common:keep_both"),
      value: "keepBoth",
    },
  ];
};

const ConflictingLabelModal = ({
  handleButton1Click,
  handleButton2Click,
  conflictingResources = [],
  styles,
  t,
  testId,
}) => {
  const radioOptions = getRadioButtonOptions({ t });

  const [selectedOption, setSelectedOption] = useState(
    _.first(radioOptions).value
  );

  const getMediaCardProps = resource => {
    if (resource.resourceType === "FILE") {
      const fileAttachment = _.get(resource, "attachment", {});
      return {
        name: _.get(fileAttachment, "name", ""),
        type: _.get(fileAttachment, "type", ""),
        mimeType: _.get(fileAttachment, "mimeType", ""),
        size: _.get(fileAttachment, "metadata.size", ""),
      };
    }

    return {
      name: _.get(resource, "label", ""),
      type: _.get(resource, "resourceType", ""),
    };
  };

  const numOfDuplicates = _.size(conflictingResources);

  return (
    <Modal
      width="552px"
      height="max-content"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <Modal.Header title={t("common:duplicates_found")} isClosable={false} />

      <Modal.Body style={styles.modalBody}>
        <div className={classes.subtitle}>
          {t("common:duplicates_found_description")}
        </div>

        <RadioButtonList
          options={radioOptions}
          value={selectedOption}
          updateInputField={({ selectedOption }) => {
            setSelectedOption(selectedOption);
          }}
          name="selectedOption"
          useCardSelection={true}
          listContainerStyle={styles.radioButtonListContainerStyles}
          testId={`${testId}-radioButtonList`}
        />

        {numOfDuplicates ? (
          <div className={classes.duplicateFileContainer}>
            <div className={classes.fileListHeader}>
              {t("common:duplicate_found_with_count", {
                count: numOfDuplicates,
              })}
            </div>
            <div className={classes.fileListWrapper}>
              {_.map(conflictingResources, resource => (
                <MediaCard
                  key={resource.resourceMapId}
                  {...getMediaCardProps(resource)}
                />
              ))}
            </div>
          </div>
        ) : null}
      </Modal.Body>

      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button
            size="large"
            variant="outlined-subtle"
            onClick={handleButton1Click}
            testId={`${testId}-footer-cancel`}
          >
            {t("common:cancel")}
          </Button>
          <Button
            size="large"
            variant="progressive"
            onClick={() => {
              handleButton2Click(selectedOption);
            }}
            testId={`${testId}-footer-upload`}
          >
            {t("common:upload")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ConflictingLabelModal.defaultProps = {
  styles: {
    modalBody: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    radioButtonListContainerStyles: {
      flexWrap: "nowrap",
      gap: "20px",
    },
  },
};

export default ConflictingLabelModal;
